import { render, staticRenderFns } from "./attributes-column.vue?vue&type=template&id=2e39af9e"
import script from "./attributes-column.vue?vue&type=script&lang=js"
export * from "./attributes-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports